import * as React from 'react';
import { MediaQuery, Price } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { withIntl } from '@grandvisionhq/state';
import { isPlainObject, getLocalizedValue, getLocalizedAttrValue, getAttrValue } from '@grandvisionhq/utils';

class LensPacksItem extends React.Component {
    getDioptries(str) {
        return str.replace(/[a-zA-Z]/g, '').replace(/\s+/g, '').replace(/[{()}]/g, '');
    }
    render() {
        const { isSelected , intl , currentBreakpoint , price , item , useIncludedLensPack  } = this.props;
        // TODO: type this properly without any but it's way to messy atm
        // Special instance where the enum key is needed
        const packAttribute = item.attributes.find((attribute)=>attribute.name === 'pack'
        );
        const type = isPlainObject(packAttribute) ? packAttribute.value.key : '';
        const packName = isPlainObject(packAttribute) && getLocalizedValue(packAttribute.value, intl.locale);
        const thicknessValue = getLocalizedAttrValue(item, 'thickness', intl.locale);
        const thickness = thicknessValue.split('(')[0];
        const dioptries = this.getDioptries(thicknessValue);
        const voucher = getAttrValue(item, 'voucher');
        const voucherObj = isPlainObject(voucher);
        const voucherValue = voucherObj ? Number(voucher === null || voucher === void 0 ? void 0 : voucher.centAmount) : 0;
        const isSelectedClass = isSelected ? '_is_selected' : '';
        if (currentBreakpoint === MediaQuery.BreakpointName.PHONE || currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE) {
            return /*#__PURE__*/ React.createElement("label", {
                className: `lens-packs-accordion-item lens-packs-accordion-item--${type} ${isSelectedClass}`
            }, /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-accordion-item__header"
            }, /*#__PURE__*/ React.createElement("input", {
                className: "lens-packs-accordion-item__radio",
                type: "radio",
                name: "ssp-lens-pack",
                value: type,
                "aria-checked": isSelected,
                checked: isSelected,
                onChange: this.handleChange
            }), /*#__PURE__*/ React.createElement(Heading, {
                variant: "smallest"
            }, packName)), /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-accordion-item__body"
            }, /*#__PURE__*/ React.createElement("ul", null, item.benefits.map((benefit)=>benefit.value && /*#__PURE__*/ React.createElement("li", {
                    key: benefit.name
                }, benefit.label)
            )), /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-accordion-item__price"
            }, item.isIncluded ? intl.getLabel('products.included') : /*#__PURE__*/ React.createElement(React.Fragment, null, "+", ' ', /*#__PURE__*/ React.createElement(Price, {
                value: price.value.centAmount,
                centAmount: true,
                currency: intl.currency
            }))), !item.isIncluded && !!voucherValue && /*#__PURE__*/ React.createElement("p", {
                className: "lens-packs-accordion-item__voucher"
            }, intl.getLabel('products.ssp.voucher.label'), /*#__PURE__*/ React.createElement(Price, {
                value: voucherValue,
                centAmount: true,
                currency: intl.currency
            }))));
        } else {
            const visualFieldValue = getLocalizedAttrValue(item, 'visualField', intl.locale);
            const higherTitle = visualFieldValue ? 'lens-packs-cell--title--with-visual-field' : '';
            return /*#__PURE__*/ React.createElement("label", {
                className: `lens-packs-column ${isSelectedClass}`
            }, /*#__PURE__*/ React.createElement("div", {
                className: `lens-packs-cell lens-packs-cell--type lens-packs-cell--${type}`
            }, /*#__PURE__*/ React.createElement(Heading, {
                variant: "smallest"
            }, packName)), /*#__PURE__*/ React.createElement("div", {
                className: `lens-packs-cell lens-packs-cell--title ${higherTitle}`
            }, /*#__PURE__*/ React.createElement(Heading, {
                variant: "subheading1"
            }, thickness), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("small", {
                className: "lens-packs-cell__dioptry"
            }, "(", dioptries, " ", intl.getLabel('products.unit.dioptries'), ")")), visualFieldValue && /*#__PURE__*/ React.createElement("small", {
                className: "lens-packs-cell__visual-field"
            }, visualFieldValue)), item.benefits.map((benefit)=>{
                const checked = benefit.value ? 'check' : 'no-check';
                return /*#__PURE__*/ React.createElement("div", {
                    key: benefit.name,
                    className: `lens-packs-cell lens-packs-cell--${checked}`
                });
            }), /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-cell lens-packs-cell--footer"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-cell__price"
            }, useIncludedLensPack && item.isIncluded ? intl.getLabel('products.included') : /*#__PURE__*/ React.createElement("span", null, useIncludedLensPack && '+ ', ' ', /*#__PURE__*/ React.createElement(Price, {
                value: price.value.centAmount,
                centAmount: true,
                currency: intl.currency
            }))), !item.isIncluded && !!voucherValue && /*#__PURE__*/ React.createElement("p", {
                className: "lens-packs-cell__voucher"
            }, /*#__PURE__*/ React.createElement("small", null, intl.getLabel('products.ssp.voucher.label')), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement(Price, {
                value: voucherValue,
                centAmount: true,
                currency: intl.currency
            })), /*#__PURE__*/ React.createElement("input", {
                className: "lens-packs-cell__radio",
                type: "radio",
                name: "ssp-lens-pack",
                value: type,
                "aria-checked": isSelected,
                checked: isSelected,
                onChange: this.handleChange
            })));
        }
    }
    constructor(...args){
        super(...args);
        this.handleChange = ()=>{
            this.props.onChange(this.props.value);
        };
    }
}
var LensPacksItem$1 = withIntl(MediaQuery.WithBreakpoints(LensPacksItem));

export { LensPacksItem, LensPacksItem$1 as default };
//# sourceMappingURL=LensPacksItem.js.map
